import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Sarah', 'María', 'Ana', 'Carmen', 'Isabella', 'Sofía', 'Valentina', 'Camila', 'Lucía', 'Elena'];
const CITIES = ['Miami', 'Los Angeles', 'New York', 'Houston', 'Chicago', 'San Diego', 'Phoenix', 'Dallas', 'San Antonio', 'San José'];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: NAMES[0],
    city: CITIES[0],
    price: '$35.91'
  });
  // Check for mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // Visibility loop with randomization
  useEffect(() => {
    if (!isMobile) return;
    const randomizeData = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomPrice = Math.random() < 0.75 ? '$35.91' : '$11.97';
      setCurrentData({
        name: randomName,
        city: randomCity,
        price: randomPrice
      });
    };
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const showNotification = () => {
      randomizeData();
      setIsVisible(true);
      // Hide after 3 seconds
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        // Show again after 6 seconds
        showTimeout = setTimeout(showNotification, 6000);
      }, 3000);
    };
    // Initial delay before first notification
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 2000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isMobile]);
  if (!isMobile) return null;
  return <div className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4" data-id="element-291">
      <AnimatePresence data-id="element-292">
        {isVisible && <motion.div initial={{
        y: 100,
        opacity: 0,
        scale: 0.9
      }} animate={{
        y: 0,
        opacity: 1,
        scale: 1
      }} exit={{
        y: 100,
        opacity: 0,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} className="w-full max-w-sm" data-id="element-293">
            <div className="bg-white/90 backdrop-blur-md rounded-2xl shadow-xl border border-gray-200/50 p-3 flex items-center gap-3" data-id="element-294">
              {/* Product Image */}
              <div className="flex-shrink-0" data-id="element-295">
                <img src="https://cdn.magicpatterns.com/uploads/jBnaXzW3oKBwpUa53k7ANB/mente-rica-fondoblanco.png" alt="Mente de Rica" className="w-12 h-12 rounded-xl object-cover bg-gray-100 border border-gray-100" data-id="element-296" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-297">
                <p className="text-[13px] leading-tight text-gray-900" data-id="element-298">
                  <span className="font-semibold" data-id="element-299">{currentData.name}</span> from{' '}
                  <span className="font-semibold" data-id="element-300">{currentData.city}</span>
                </p>
                <p className="text-[13px] leading-tight text-gray-600 mt-0.5" data-id="element-301">
                  just purchased{' '}
                  <span className="italic text-gray-800" data-id="element-302">Mente de Rica</span>
                </p>
                <p className="text-[13px] font-bold text-[#D4AF37] mt-0.5" data-id="element-303">
                  {currentData.price}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}